import { constants } from './constants';

const get = (): ConfigItem[] => JSON.parse(localStorage.getItem(constants.SECRETS_LS_KEY) || '[]');

const set = (items: ConfigItem[]): void => localStorage.setItem(constants.SECRETS_LS_KEY, JSON.stringify(items));

export const ConfigItemsStorage = { get, set };
